<!-- src/App.vue -->
<template>
  <div id="app">
    <div
      v-if="!$store.getters.isSessionReady"
      class="startup-loading"
      role="status"
      aria-live="polite"
    >
      <span class="startup-loading__spinner" aria-hidden="true"></span>
      <span>系統載入中…</span>
    </div>
    <router-view v-else />
    <!-- Integrate AlertDialog here -->
    <AlertDialog
      :modelValue="$store.getters.getAlertDialogVisible"
      :title="$store.getters.getAlertDialogTitle"
      :message="$store.getters.getAlertDialogMessage"
      :type="$store.getters.getAlertDialogType"
      :maxWidth="$store.getters.getAlertDialogMaxWidth"
      @update:modelValue="handleAlertDialogClose"
    >
      <!-- Slot content for the AlertDialog - only render if there's data AND no simple message -->
      <div v-if="$store.getters.getTodayDeliveryOrdersData.length > 0 && !$store.getters.getAlertDialogMessage" class="delivery-table-container">
        <table class="delivery-table">
          <thead>
            <tr>
              <th>客戶名稱</th>
              <th>交貨日期</th>
              <th>產品名稱</th>
              <th>數量</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="order in $store.getters.getTodayDeliveryOrdersData" :key="order.id">
              <!-- Robust check for order.items -->
              <template v-if="order.items && order.items.length > 0">
                <tr v-for="(item, itemIndex) in order.items" :key="order.id + '-' + item.id">
                  <!-- Only show customer_name and delivery_date for the first item of each order -->
                  <td v-if="itemIndex === 0" :rowspan="order.items.length">{{ order.customer_name || 'N/A' }}</td>
                  <td v-if="itemIndex === 0" :rowspan="order.items.length">{{ order.delivery_date || 'N/A' }}</td>
                  <td>{{ item.product_name || 'N/A' }}</td>
                  <td>{{ item.quantity || 'N/A' }}</td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="4">訂單 {{ order.delivery_number || order.id }} 沒有產品明細。</td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
      <!-- No need for v-else here, as simple messages are now handled by the 'message' prop -->
    </AlertDialog>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import AlertDialog from './components/AlertDialog.vue'; // Import your AlertDialog component

const store = useStore();

const handleAlertDialogClose = (newValue) => {
  if (!newValue) {
    store.commit('hideAlertDialog');
  }
};
</script>

<style>
.startup-loading {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: #31506f;
  background: #f5f7fa;
  font-size: 1rem;
}

.startup-loading__spinner {
  width: 1.5rem;
  height: 1.5rem;
  border: 3px solid #c8d7e6;
  border-top-color: #1976d2;
  border-radius: 50%;
  animation: startup-spin 0.8s linear infinite;
}

@keyframes startup-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Add some basic styling for the table within the AlertDialog */
.delivery-table-container {
  max-height: none;
  overflow-y: visible;
  margin-top: 10px;
  margin-bottom: 10px;
}

.delivery-table {
  width: 100%;
  border-collapse: collapse;
  color: #333; /* Changed text color to dark gray for better contrast */
}

.delivery-table th,
.delivery-table td {
  border: 1px solid rgba(0, 0, 0, 0.2); /* Darker border for better visibility */
  padding: 8px;
  text-align: left;
  vertical-align: top;
}

.delivery-table th {
  background-color: rgba(0, 0, 0, 0.1); /* Slightly darker background for headers, but still light */
  font-weight: bold;
}

/* Removed alternating row colors and hover effects for consistency */
.delivery-table tbody tr {
  background-color: transparent; /* Ensure no background color by default */
}

.delivery-table tbody tr:hover {
  background-color: transparent; /* No hover effect */
}
</style>
